/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} General_Pumps_PermutationInputs */



/**
* | output |
* | --- |
* | "General changeover of dual pumps" |
*
* @param {General_Pumps_PermutationInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const general_pumps_permutation = /** @type {((inputs?: General_Pumps_PermutationInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<General_Pumps_PermutationInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("General changeover of dual pumps")
	return /** @type {LocalizedString} */ ("Permutation général des pompes doubles")
});